export const errors = {
  SUCCESS: {
    loggerInfo: "Signup Event Success",
    errorText: null,
  },
  IN_SESSION: {
    loggerInfo: "User In Session",
    errorText: "User In Session",
  },
  CUSTOMER_RETRY: {
    loggerInfo: "Signup Event failure customer retry",
    errorText: "Oops, we've hit a glitch. Try entering the details again.",
  },
  AUTO_RETRY: {
    loggerInfo: "Signup Event failure auto retry",
    errorText: "Oops, we've hit a glitch. Try entering the details again.",
  },
  DUPLICATE_SIGNUP: {
    loggerInfo: "Signup Event failure Duplicate signup",
    errorText:
      "Looks like there’s already an account with that email address. To access it, please follow the link we sent to your email address.",
  },
  INVALID_INPUT: {
    loggerInfo: "Signup Event failure invalid input",
    errorText:
      "Oh ho! That's an invalid input. Try entering valid details again.",
  },
  CAPTCHA_VALIDATION_FAILED: {
    loggerInfo: "Signup Event failure captcha validation",
    errorText: "Oh ho! Captcha validation failed",
  },
  UNKNOWN: {
    loggerInfo: "Signup Unknown Error",
    errorText: "Oops, we've hit a glitch. Try entering the details again.",
  },
}
